import { memo } from "react";
import { cn } from "@/lib/utils";

type SpinnerProps = {
  size?: number;
  strokeWidth?: number;
  speed?: number;
  arc?: number; // от 0 до 360
} & React.ComponentProps<"svg">;

const Spinner = ({
  size = 40,
  strokeWidth = 4,
  speed = 0.8,
  arc = 180,
  className,
}: SpinnerProps) => {
  const radius = 20;
  const circumference = 2 * Math.PI * radius;
  const dashArray = (arc / 360) * circumference;
  const dashOffset = circumference - dashArray;

  return (
    <svg
      className={cn("animate-spin text-blue-500", className)}
      width={size}
      height={size}
      viewBox="0 0 50 50"
      style={{ animationDuration: `${speed}s` }}
    >
      <circle
        cx="25"
        cy="25"
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeDasharray={dashArray}
        strokeDashoffset={dashOffset}
      />
    </svg>
  );
};

export default memo(Spinner);
